"use strict";
const moment = require('moment');
const mapKeys = require('lodash/mapKeys');
const snakeCase = require('lodash/snakeCase');
const includes = require('lodash/includes');
const { JOB_DATA_TYPES, SOURCE_ID, STATUS_ENUM, JOBS_TO_EXECUTE } = require('./consts');
const shouldShowProcessedRecords = (dataType) => JOBS_TO_EXECUTE.includes(dataType);
const getConnectionFields = (source, data) => {
    switch (source) {
        case SOURCE_ID.SFTP:
            return { sftp_host_name: data.sftpHostName, sftp_file_path: data.sftpFilePath };
        case SOURCE_ID.S3:
            return { s3_bucket_name: data.s3BucketName, s3_path: data.s3Path };
        case SOURCE_ID.MINIO:
            return { s3_endpoint_url: data.s3EndpointUrl, s3_bucket_name: data.s3BucketName, s3_path: data.s3Path };
        default:
            return {};
    }
};
const showErrorMessage = (status) => status.toLowerCase() === STATUS_ENUM.FAILURE || status.toLowerCase() === STATUS_ENUM.PARTIAL_SUCCESS;
const parseDuration = (duration) => moment.duration(duration, moment.HTML5_FMT.TIME_MS).asMilliseconds();
const errorMapFunction = ({ code, description, occurrences, rows }) => ({ code, description, occurrences, rows });
const generateWebhookPayload = (payloadData, connectorData = {}) => {
    const timestamp = new Date().getTime();
    const connectionMetadata = getConnectionFields(payloadData.jobData.connectorName, connectorData);
    const { errors = [], ignoredErrors = [], useWarningsErrorsFeatureUi = false } = payloadData;
    const payload = {
        type: 'upload_event',
        id: payloadData.id,
        service_id: payloadData.serviceId,
        source: 'ihdf',
        timestamp,
        data: {
            upload_id: payloadData.jobId,
            upload_desc: payloadData.jobData.description,
            schedule_type: payloadData.jobData.schedule === 'ondemand' ? 'one time' : 'recurring',
            status: payloadData.status.toLowerCase(),
            step: payloadData.step.toLowerCase(),
            step_timestamp: new Date(payloadData.time).getTime(),
            connection: { connection_name: 'ihdf', ...connectionMetadata },
            file_name: payloadData.fileName,
        },
    };
    const supportedDataTypes = [
        JOB_DATA_TYPES.ACCOUNT,
        JOB_DATA_TYPES.USER,
        JOB_DATA_TYPES.COLLECTION,
        JOB_DATA_TYPES.USAGE,
        JOB_DATA_TYPES.ACCOUNT_USER,
        JOB_DATA_TYPES.USAGE_AGGREGATIONS,
        JOB_DATA_TYPES.TOTANGO_USER,
        JOB_DATA_TYPES.HISTORICAL_CLICK_STREAM,
        JOB_DATA_TYPES.TASK,
        JOB_DATA_TYPES.TASK_OUT,
        JOB_DATA_TYPES.TOUCHPOINT,
        JOB_DATA_TYPES.TOUCHPOINT_OUT,
        JOB_DATA_TYPES.INSIGHTS_OUT,
        JOB_DATA_TYPES.CAMPAIGN_TOUCH_OUT,
        JOB_DATA_TYPES.ACCOUNT_USER_OUT,
        JOB_DATA_TYPES.ACCOUNT_FOREIGN_KEY,
        JOB_DATA_TYPES.OPPORTUNITY,
    ];
    if (includes(supportedDataTypes, payloadData.accessLevel)) {
        const recordFields = {
            totalRecords: payloadData.processingStatus.totalRecords || 0,
            ...(shouldShowProcessedRecords(payloadData.accessLevel) && { processedRecords: payloadData.processingStatus.processedRecords || 0 }),
            invalidRecords: payloadData.processingStatus.invalidRecords || 0,
            ...(!useWarningsErrorsFeatureUi && { duplicateRecords: payloadData.processingStatus.duplicateRecords || 0 }),
        };
        Object.assign(payload.data, mapKeys(recordFields, (v, k) => snakeCase(k)));
    }
    if (payloadData.processingStatus.duration) {
        Object.assign(payload.data, { duration_ms: parseDuration(payloadData.processingStatus.duration) });
    }
    if (showErrorMessage(payloadData.status)) {
        if (useWarningsErrorsFeatureUi) {
            Object.assign(payload.data, {
                ...(errors.length && { errors: errors.map(errorMapFunction) }),
                ...(ignoredErrors.length && { mutedErrors: ignoredErrors.map(errorMapFunction) }),
            });
        }
        else {
            Object.assign(payload.data, {
                error: {
                    error_desc: payloadData.shortDesc,
                    error_info: payloadData.errorMessage,
                },
            });
        }
    }
    return payload;
};
module.exports = {
    generateWebhookPayload,
    shouldShowProcessedRecords,
};
//# sourceMappingURL=utils.js.map